export default function RobotsSpinner({ size = 74 }: { size?: number }) {
  const dot = Math.round(size * 0.405);
  const gap = size - dot * 2;
  return (
    <div className="robots-spinner">
      <div
        className="robots-spinner-inner"
        style={{ gap, '--rs-dot': `${dot}px` } as React.CSSProperties}
      >
        <span className="rs-dot rs-dot--r" />
        <span className="rs-dot rs-dot--b" />
        <span className="rs-dot rs-dot--y" />
        <span className="rs-dot rs-dot--g" />
      </div>
    </div>
  );
}
